import { render } from "./PromotionPage.vue?vue&type=template&id=4c797649"
import script from "./PromotionPage.vue?vue&type=script&lang=js"
export * from "./PromotionPage.vue?vue&type=script&lang=js"

import "./PromotionPage.vue?vue&type=style&index=0&id=4c797649&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__